/**
 * 订单状态字典
 * 会话列表消息前缀、聊天头部、右侧订单信息模块共用，保证文案与样式一致
 *
 * 按群类型 groupType 区分：
 *   3 - 租号订单(order_info.order_status)：0待支付 1交易中 2结算中 3已取消 5售后中 6已完成
 *   4 - 跑刀代肝订单(boost_order.order_status)：0待支付 1验号中(待指派) 2验号中(已指派) 3交易中 4结算中 5已完成 6已取消
 *   5 - 道具/捆绑包订单(product_order.order_status)：0待支付 1交易中 2已完成 3已取消
 *
 * 配色规范（每个状态色相唯一，避免 --im-success 与 --im-primary-strong 在白色主题下同色的问题）：
 *   待支付 → warning 琥珀，待用户处理
 *   交易中 → success 青绿，正常进行中
 *   结算中 → info     蓝，平台处理中
 *   售后中 → danger  红，异常介入
 *   已完成 → text    常规深色，终态（字重 500 与已取消区分）
 *   已取消 → muted   浅灰，终态失效（字重 400，视觉最弱）
 */
const orderStatus = {
  // 租号订单
  3: {
    0: { label: '待支付', color: 'var(--im-warning)', weight: 600 },
    1: { label: '交易中', color: 'var(--im-success)', weight: 600 },
    2: { label: '结算中', color: 'var(--im-info)', weight: 600 },
    3: { label: '已取消', color: 'var(--im-muted)', weight: 400 },
    5: { label: '售后中', color: 'var(--im-danger)', weight: 600 },
    6: { label: '已完成', color: 'var(--im-text)', weight: 500 },
  },
  // 跑刀代肝订单
  4: {
    0: { label: '待支付', color: 'var(--im-warning)', weight: 600 },
    1: { label: '验号中（待指派）', color: 'var(--im-info)', weight: 600 },
    2: { label: '验号中（已指派）', color: 'var(--im-info)', weight: 600 },
    3: { label: '交易中', color: 'var(--im-success)', weight: 600 },
    4: { label: '结算中', color: 'var(--im-info)', weight: 600 },
    5: { label: '已完成', color: 'var(--im-text)', weight: 500 },
    6: { label: '已取消', color: 'var(--im-muted)', weight: 400 },
  },
  // 道具/捆绑包订单
  5: {
    0: { label: '待支付', color: 'var(--im-warning)', weight: 600 },
    1: { label: '交易中', color: 'var(--im-success)', weight: 600 },
    2: { label: '已完成', color: 'var(--im-text)', weight: 500 },
    3: { label: '已取消', color: 'var(--im-muted)', weight: 400 },
  },
}

// 取订单状态配置，状态为空或非法群类型时返回 null
export const getOrderStatus = (groupType, status) => {
  if (status === undefined || status === null || status === '') return null
  return (orderStatus[groupType] || {})[status] || null
}

// 取订单状态文案
export const getOrderStatusLabel = (groupType, status) => getOrderStatus(groupType, status)?.label || ''

// 状态色淡化比例：与主题表面色混合，避免小字号下颜色过重
// 浅色主题混白后变柔和，深色主题混深色表面后同样降低刺激，两端对比度仍可读
const SOFTEN_RATIO = 72

// 取订单状态内联样式（颜色 + 字重），无匹配状态时返回空对象
export const getOrderStatusStyle = (groupType, status) => {
  const conf = getOrderStatus(groupType, status)
  if (!conf) return {}
  return {
    color: `color-mix(in srgb, ${conf.color} ${SOFTEN_RATIO}%, var(--im-surface))`,
    fontWeight: conf.weight,
  }
}

export default orderStatus
